(() => {
  'use strict';
  const d = document.getElementById('ag-international-dialog');
  if (!d || window.AdriaInternationalInquiry) return;
  window.AdriaInternationalInquiry = {openStock:(trigger,direct=false)=>open(trigger,false,direct?'direct':'stock')};
  const stock = window.AdriaStockEnquiry;
  const include = d.querySelector('[data-ag-stock-include]');
  let mode = 'international', snapshot = null, invalid = false, validating = false, approved = false, submitRevision = 0;
  const hr = d.dataset.lang === 'hr';
  const form = d.querySelector('form'), products = d.querySelector('#AgInquiryProducts');
  const preview = d.querySelector('[data-ag-inquiry-products-preview]');
  const priceNote = d.querySelector('[data-ag-inquiry-price-note]');
  const successResult = d.querySelector('[data-ag-inquiry-result=success]');
  const fieldsContainer = d.querySelector('[data-ag-inquiry-fields-container]');
  let showingSuccess = false;
  const submit = d.querySelector('[data-ag-inquiry-submit]'), status = d.querySelector('[data-ag-inquiry-items-status]');
  const retry = d.querySelector('[data-ag-inquiry-refresh]');
  // Only identifies our submission across Shopify's redirect/CAPTCHA. Never proof of success.
  const pendingKey = 'ag-inquiry-pending';
  function pendingSubmission() {
    try {
      const pending = JSON.parse(sessionStorage.getItem(pendingKey));
      return pending && Date.now() - pending.at < 30 * 60 * 1000 &&
        (pending.path === location.pathname || /\/contact$/.test(location.pathname));
    } catch { return false; }
  }
  const text = hr ? {
    loading:'Osvježavamo popis proizvoda…', ready:'Popis proizvoda i količina dodan je uz upit.',
    error:'Popis proizvoda nije osvježen. Pokušajte ponovno ili u poruci navedite željene proizvode i količine.',
    empty:'Košarica je prazna. U poruci navedite koji vas proizvodi zanimaju.',
    cart:'Proizvodi u košarici:', product:'Proizvod sa stranice:'
  } : {
    loading:'Updating the product list…', ready:'Products and quantities have been included in your enquiry.',
    error:'The product list could not be updated. Try again, or include the products and quantities in your message.',
    empty:'Your cart is empty. Tell us which products interest you in your message.',
    cart:'Products in your cart:', product:'Product from this page:'
  };
  let opener = null, shellId = '', overflow = '', sourceProduct = '', sourceUrl = '', controller = null, revision = 0;
  let fetching = false, submitting = false, unlockTimer = null;
  const syncSubmit = () => { if (submit) submit.disabled = fetching || submitting || invalid || validating; };
  // Render only customer-facing fields. Identifiers remain in the hidden contact payload.
  function showProducts(groups = []) {
    if (!preview) return;
    const fragment = document.createDocumentFragment();
    const line = (parent, tag, value, className) => {
      const node = document.createElement(tag); node.textContent = value;
      if (className) node.className = className;
      parent.append(node); return node;
    };
    groups.filter(group => group.items.length).forEach(group => {
      const section = line(fragment, 'section', '', 'ag-inquiry-product-group');
      line(section, 'h3', group.title);
      group.items.forEach(item => {
        const row = line(section, 'div', '', 'ag-inquiry-product-row');
        line(row, 'p', item.title, 'ag-inquiry-product-title');
        line(row, 'p', [item.variant, `${item.quantity} ${hr ? 'kom' : item.quantity === 1 ? 'item' : 'items'}`].filter(Boolean).join(' · '));
        if (item.price) line(row, 'p', `${hr ? 'Informativna cijena po komadu' : 'Indicative price per item'}: ${item.price}`);
        if (item.available) line(row, 'p', hr ? 'Sada je dostupno za kupnju.' : 'Now available to buy.');
      });
    });
    preview.replaceChildren(fragment);
  }
  function productHeading() {
    return sourceProduct ? `${text.product}\n${sourceProduct}\n${sourceUrl}\n\n` : '';
  }
  async function refreshProducts() {
    if (!products) return;
    if (stock && (mode !== 'international' || !sourceProduct)) {
      const version=++revision;
      fetching=true;invalid=true;snapshot=null;syncSubmit();retry.hidden=true;status.textContent=text.loading;showProducts();
      try {
        const result=await stock.selection(mode,!!include?.checked);
        if(version!==revision)return;
        snapshot=result;products.value=result.body;showProducts(result.groups);invalid=false;status.textContent=stock.text.ready;
      } catch(error) {
        if(version!==revision)return;
        products.value='';status.textContent=error.message===stock.text.duplicate?stock.text.duplicate:stock.text.error;
        retry.hidden=false;
      } finally {if(version===revision){fetching=false;syncSubmit();}}
      return;
    }
    controller?.abort(); controller = new AbortController();
    const request = controller, version = ++revision;
    fetching = true; syncSubmit(); status.textContent = text.loading; retry.hidden = true;showProducts();
    const timeout = setTimeout(() => request.abort(), 8000);
    try {
      const response = await fetch(d.dataset.cartUrl, {credentials:'same-origin',cache:'no-store',signal:request.signal,headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('cart');
      if (version !== revision) return;
      const lines = cart.items.map(item => {
        const name = item.product_title || item.title || '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? ` / ${item.variant_title}` : '';
        const sku = item.sku ? ` | SKU: ${item.sku}` : '';
        return `${item.quantity} × ${name}${variant}${sku} | Product ID: ${item.product_id || ''} | Variant ID: ${item.variant_id || item.id || ''}`;
      });
      products.value = productHeading() + (lines.length ? text.cart + '\n' + lines.join('\n') : '');
      showProducts([
        {title:text.product,items:sourceProduct ? [{title:sourceProduct,quantity:1}] : []},
        {title:text.cart,items:cart.items.map(item => ({title:item.product_title || item.title || '',variant:item.variant_title === 'Default Title' ? '' : item.variant_title,quantity:item.quantity,price:cart.currency && Number.isFinite(item.final_price) ? new Intl.NumberFormat(hr?'hr-HR':'en-GB',{style:'currency',currency:cart.currency}).format(item.final_price/100) : ''}))}
      ]);
      status.textContent = lines.length || sourceProduct ? text.ready : text.empty;
    } catch {
      if (version !== revision) return;
      // Do not silently email a stale cart snapshot after a failed refresh.
      products.value = productHeading(); status.textContent = text.error; retry.hidden = false;
    } finally {
      clearTimeout(timeout);
      if (version === revision) { fetching = false; syncSubmit(); }
    }
  }
  function open(trigger, response = false, requestedMode = 'international') {
    if (d.open || typeof d.showModal !== 'function') return;
    showingSuccess = !!(response && successResult);
    if(successResult)successResult.hidden=!showingSuccess;
    if(fieldsContainer)fieldsContainer.hidden=showingSuccess;
    opener = trigger;submitRevision++;validating=false;
    const resume=response && stock ? stock.pendingInfo() : null;
    mode=resume?.mode || requestedMode;invalid=false;approved=false;snapshot=null;
    if(priceNote)priceNote.textContent=mode==='international'
      ? (hr?'Mogućnosti kupnje i dostave potvrdit ćemo e-mailom.':'We’ll confirm purchase and delivery options by email.')
      : (hr?'Dostupnost, konačnu cijenu i rok pripreme potvrdit ćemo e-mailom.':'We’ll confirm availability, the final price and preparation time by email.');
    const topic=form?.querySelector('[name="contact[Topic]"]');
    if(topic)topic.value=mode==='international'?'International purchase enquiry':'Product availability enquiry';
    if(include){
      include.checked=!!resume?.include;
      const label=d.querySelector('[data-ag-stock-include-label]');
      label.hidden=showingSuccess||mode==='direct'||(mode==='international'&&!stock.hasItems());
      d.querySelector('[data-ag-stock-include-text]').textContent=mode==='international'?(hr?'Uključi i proizvode s popisa za upit':'Also include products from the enquiry list'):(hr?'Uključi i dostupne proizvode iz košarice':'Include available products from the cart');
      const warning=d.querySelector('[data-ag-stock-direct-note]');warning.hidden=mode!=='direct';warning.textContent=stock.text.storage;
    }
    shellId = trigger?.closest('[data-ag-cart-shell],#MinimogCartDrawer,#MinimogCart')?.id || '';
    sourceProduct = trigger?.dataset.agInquiryProduct || '';
    sourceUrl = '';
    if (sourceProduct && trigger.dataset.agInquiryUrl) {
      const url = new URL(trigger.dataset.agInquiryUrl, location.origin);
      if (url.origin === location.origin) sourceUrl = url.href;
    }
    overflow = document.body.style.overflow;
    d.showModal(); document.body.style.overflow = 'hidden';
    trigger?.setAttribute('aria-expanded','true');
    d.querySelector('.ag-inquiry-scroll').scrollTop = 0;
    (response ? d.querySelector('[data-ag-inquiry-result]') : d.querySelector('h2'))?.focus({preventScroll:true});
    if (!response) refreshProducts();
    else if (showingSuccess) {
      stock?.confirmed();
      // Keep the confirmation for this opening only; refresh must not replay it.
      const url=new URL(location.href);url.searchParams.delete('contact_posted');
      if(['#AgInternationalContact','#contact_form'].includes(url.hash))url.hash='';
      history.replaceState(history.state,'',url.href);
      const message=form?.querySelector('[name="contact[body]"]');if(message)message.value='';
      const date=form?.querySelector('[name="contact[Preferred date]"]');if(date)date.value='';
    }
    else if (stock && resume) refreshProducts();
  }
  function close() { if (d.open) d.close(); }
  d.addEventListener('close', () => {
    revision++; submitRevision++; validating=false; controller?.abort(); fetching = false; syncSubmit();
    document.body.style.overflow = overflow;
    opener?.setAttribute('aria-expanded','false');
    const shell=document.getElementById(shellId);
    const target = opener?.isConnected ? opener : (mode==='stock' ? shell?.querySelector('[data-stock-action=open]') : shell?.querySelector('[data-ag-inquiry-open]')) || shell?.querySelector('[name=checkout], .m-cart-drawer__close');
    target?.focus({preventScroll:true});
  });
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-ag-inquiry-open]');
    if (trigger && typeof d.showModal === 'function') { e.preventDefault(); open(trigger); return; }
    if (e.target.closest('[data-ag-inquiry-close]')) { e.preventDefault(); close(); }
    if (e.target.closest('[data-ag-inquiry-refresh]')) { e.preventDefault(); refreshProducts(); }
    if (e.target === d) {
      const r=d.getBoundingClientRect();
      if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) close();
    }
  });
  // Keep the underlying cart's focus trap and Escape handler out of this modal.
  document.addEventListener('focusin', e => { if (d.open && d.contains(e.target)) e.stopImmediatePropagation(); }, true);
  document.addEventListener('keydown', e => {
    if (!d.open) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    e.stopImmediatePropagation();
    const nodes = [...d.querySelectorAll('a[href],button,input,select,textarea,iframe,[tabindex="0"]')].filter(n=>!n.disabled&&!n.closest('[hidden]')&&n.getClientRects().length);
    const first=nodes[0],last=nodes[nodes.length-1];
    if (!first) {e.preventDefault();return;}
    if (e.shiftKey && (document.activeElement===first||!nodes.includes(document.activeElement))) {e.preventDefault();last.focus();}
    else if (!e.shiftKey && (document.activeElement===last||!nodes.includes(document.activeElement))) {e.preventDefault();first.focus();}
  },true);
  include?.addEventListener('change',()=>{approved=false;refreshProducts();});
  document.addEventListener('ag:stock:change',()=>{if(d.open&&!showingSuccess){approved=false;refreshProducts();}});
  form?.addEventListener('submit', e => {
    if(fetching || submitting || validating){e.preventDefault();e.stopImmediatePropagation();return;}
    if(stock && (mode !== 'international' || !sourceProduct)){
      if(invalid || validating){e.preventDefault();return;}
      if(!approved){
        e.preventDefault();e.stopImmediatePropagation();validating=true;syncSubmit();const attempt=++submitRevision;
        refreshProducts().then(()=>{if(attempt!==submitRevision)return;validating=false;syncSubmit();if(!invalid&&snapshot&&d.open){approved=true;form.requestSubmit();}});
        return;
      }
      approved=false;
      if(snapshot)stock.pending(snapshot,mode,!!include?.checked);
    }
    if (fetching || submitting) { e.preventDefault(); return; }
    // Store before Shopify may pause submission for CAPTCHA; no form contents are stored.
    try { sessionStorage.setItem(pendingKey, JSON.stringify({at:Date.now(),path:location.pathname})); } catch {}
    // Let Shopify handle the POST, CAPTCHA, errors and success. Never infer success from a click.
    queueMicrotask(() => {
      if (e.defaultPrevented) return;
      submitting=true;syncSubmit();
      clearTimeout(unlockTimer);
      unlockTimer=setTimeout(()=>{submitting=false;syncSubmit();},15000);
    });
  }, true);
  window.addEventListener('pageshow', () => {submitting=false;syncSubmit();});
  // Follow section replacement without recreating the form or discarding typed fields.
  let footer=null, summary=null, observer=null;
  function observeCart() {
    const cart=document.getElementById('MinimogCartDrawer');
    const next=cart?.querySelector('.m-cart-drawer__footer');
    if(next!==footer){
      observer?.disconnect();footer=next;
      if(footer){
        const fit=()=>cart.classList.toggle('ag-inquiry-long-summary',!!cart.querySelector('[data-ag-inquiry-panel]')&&footer.getBoundingClientRect().height>(window.visualViewport?.height||innerHeight)*.55);
        observer=new ResizeObserver(fit);observer.observe(footer);fit();
      }
    }
    const nextSummary=document.querySelector('[data-ag-cart-shell] [data-cart-subtotal]')?.firstElementChild;
    if(nextSummary!==summary){summary=nextSummary;if(d.open&&!sourceProduct&&!showingSuccess)refreshProducts();}
  }
  new MutationObserver(observeCart).observe(document.body,{childList:true,subtree:true});observeCart();
  const response = d.querySelector('[data-ag-inquiry-result]');
  // The Liquid result is rendered by Shopify. A pending marker alone never opens a success state.
  if (response && (location.hash === '#AgInternationalContact' || pendingSubmission())) {
    try { sessionStorage.removeItem(pendingKey); } catch {}
    open(null, true);
  }
})();
